// src/components/Register.js
import React, { useState } from "react";
import { db, auth } from "../firebase";
import { doc, setDoc } from "firebase/firestore"; // 移除 query/where/getDocs（不再需要）
import { createUserWithEmailAndPassword } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";

// 完整国家列表（不精简版）
const COUNTRY_OPTIONS = [
  { value: "", label: "Select Country / 选择国家" },
  // 亚洲主要国家
  { value: "China", label: "China / 中国" },
  { value: "India", label: "India / 印度" },
  { value: "Indonesia", label: "Indonesia / 印度尼西亚" },
  { value: "Pakistan", label: "Pakistan / 巴基斯坦" },
  { value: "Bangladesh", label: "Bangladesh / 孟加拉国" },
  { value: "Japan", label: "Japan / 日本" },
  { value: "Philippines", label: "Philippines / 菲律宾" },
  { value: "Vietnam", label: "Vietnam / 越南" },
  { value: "Iran", label: "Iran / 伊朗" },
  { value: "Turkey", label: "Turkey / 土耳其" },
  { value: "Thailand", label: "Thailand / 泰国" },
  { value: "South Korea", label: "South Korea / 韩国" },
  { value: "Malaysia", label: "Malaysia / 马来西亚" },
  { value: "Singapore", label: "Singapore / 新加坡" },
  { value: "Saudi Arabia", label: "Saudi Arabia / 沙特阿拉伯" },
  { value: "United Arab Emirates", label: "United Arab Emirates / 阿联酋" },
  // 欧洲主要国家
  { value: "Russia", label: "Russia / 俄罗斯" },
  { value: "Germany", label: "Germany / 德国" },
  { value: "France", label: "France / 法国" },
  { value: "United Kingdom", label: "United Kingdom / 英国" },
  { value: "Italy", label: "Italy / 意大利" },
  { value: "Spain", label: "Spain / 西班牙" },
  { value: "Ukraine", label: "Ukraine / 乌克兰" },
  { value: "Poland", label: "Poland / 波兰" },
  { value: "Romania", label: "Romania / 罗马尼亚" },
  { value: "Netherlands", label: "Netherlands / 荷兰" },
  { value: "Belgium", label: "Belgium / 比利时" },
  { value: "Switzerland", label: "Switzerland / 瑞士" },
  { value: "Austria", label: "Austria / 奥地利" },
  { value: "Portugal", label: "Portugal / 葡萄牙" },
  { value: "Greece", label: "Greece / 希腊" },
  { value: "Sweden", label: "Sweden / 瑞典" },
  { value: "Norway", label: "Norway / 挪威" },
  { value: "Denmark", label: "Denmark / 丹麦" },
  { value: "Finland", label: "Finland / 芬兰" },
  // 美洲主要国家
  { value: "United States", label: "United States / 美国" },
  { value: "Brazil", label: "Brazil / 巴西" },
  { value: "Mexico", label: "Mexico / 墨西哥" },
  { value: "Canada", label: "Canada / 加拿大" },
  { value: "Argentina", label: "Argentina / 阿根廷" },
  { value: "Chile", label: "Chile / 智利" },
  { value: "Colombia", label: "Colombia / 哥伦比亚" },
  { value: "Peru", label: "Peru / 秘鲁" },
  { value: "Venezuela", label: "Venezuela / 委内瑞拉" },
  { value: "Costa Rica", label: "Costa Rica / 哥斯达黎加" },
  // 非洲主要国家
  { value: "Nigeria", label: "Nigeria / 尼日利亚" },
  { value: "Egypt", label: "Egypt / 埃及" },
  { value: "South Africa", label: "South Africa / 南非" },
  { value: "Ethiopia", label: "Ethiopia / 埃塞俄比亚" },
  { value: "Kenya", label: "Kenya / 肯尼亚" },
  // 大洋洲主要国家
  { value: "Australia", label: "Australia / 澳大利亚" },
  { value: "New Zealand", label: "New Zealand / 新西兰" },
  // 其他国家统一归类
  { value: "Other", label: "Other / 其他" }
];

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nickname, setNickname] = useState("");
  const [country, setCountry] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 移除：用户名唯一性校验函数（不再需要）

  // 简化后的注册逻辑
  const handleRegister = async (e) => {
    e.preventDefault();
    // 基础校验（仅校验必填项和密码长度）
    if (!email || !password || !nickname || !country) {
      return alert("请填写所有必填项 / Please fill in all required fields");
    }
    if (password.length < 6) {
      return alert("密码长度不能少于6位 / Password must be at least 6 characters");
    }
    if (loading) return;

    setLoading(true);
    try {
      // 1. 创建 Firebase 账号（邮箱+密码）- Firebase 自动校验邮箱唯一性
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. 保存用户信息到 Firestore（昵称可重复，无校验）
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: email,
        nickname: nickname, // 昵称无需唯一
        country: country,
        authType: "email",
        registerTime: new Date(),
        lastLoginTime: new Date()
      });

      alert("注册成功！请登录 / Registration successful! Please login");
      navigate("/login"); // 跳转到登录页
    } catch (err) {
      console.error("注册失败:", err);
      let errorMsg = "注册失败 / Registration failed: ";
      // Firebase 自动返回邮箱相关错误
      if (err.code === "auth/email-already-in-use") {
        errorMsg += "该邮箱已注册 / Email already in use";
      } else if (err.code === "auth/invalid-email") {
        errorMsg += "邮箱格式错误 / Invalid email format";
      } else if (err.code === "auth/weak-password") {
        errorMsg += "密码强度不足 / Weak password";
      } else {
        errorMsg += err.message;
      }
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-pink-50 via-rose-50 to-rose-100 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6">
        <h1 className="text-2xl font-semibold mb-6" style={{ color: "#C86B85" }}>
          📝 Register / 注册账号
        </h1>

        <form onSubmit={handleRegister}>
          {/* 邮箱输入（唯一标识） */}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            placeholder="Email / 邮箱（登录用）"
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-pink-200"
            disabled={loading}
            required
          />

          {/* 密码输入 */}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password (≥6位) / 密码"
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-pink-200"
            disabled={loading}
            required
          />

          {/* 昵称输入（可重复，无校验） */}
          <input
            value={nickname}
            onChange={(e) => setNickname(e.target.value.trim())}
            placeholder="Nickname / 昵称（可重复）"
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-pink-200"
            disabled={loading}
            required
          />

          {/* 国家选择 */}
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-6 focus:outline-none focus:ring-2 focus:ring-pink-200 bg-white"
            disabled={loading}
            required
          >
            {COUNTRY_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {/* 注册按钮 */}
          <button
            type="submit"
            className={`w-full py-2 rounded-lg text-white font-semibold ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            style={{ background: "linear-gradient(90deg,#F7C6D4,#F4D19B)" }}
            disabled={loading}
          >
            {loading ? "Processing..." : "Register / 注册"}
          </button>
        </form>

        {/* 已有账号？跳转到登录页 */}
        <div className="mt-4 text-center text-gray-600">
          <span>已有账号？ / Already have an account? </span>
          <Link to="/login" className="text-pink-600 hover:underline">
            Login / 登录
          </Link>
        </div>
      </div>
    </div>
  );
}